import { render, staticRenderFns } from "./organizationReport.vue?vue&type=template&id=3c422c25&scoped=true&"
import script from "./organizationReport.vue?vue&type=script&lang=js&"
export * from "./organizationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c422c25",
  null
  
)

export default component.exports